/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import { PropertyFeatures } from '@zcode/enums'
import type { Listable, Pin, Property } from '@zcode/state-type'

export const isShortTermAvailability = (t: Listable | Property | Pin) =>
  !!t.features?.includes(PropertyFeatures.SHORT_TERM_AVAILABILITY)
